import { Breakpoint } from '@landr/maestro';
import { BaseMeta } from 'types';

const allowedNumberOfCharacters: { [key: string]: number } = {
    xs: 35,
    sm: 35,
    ms: 35,
    md: 35,
    lg: 40,
    xl: 45,
    default: 55,
};

const getMaxMetasAllowed = (
    breakpoint: Breakpoint | 'default' | 'unknown',
    metas?: BaseMeta[],
): number => {
    // The max width value will be determined by the number of characters in the filters
    let accChar = 0;

    const maxChar = allowedNumberOfCharacters[breakpoint] ?? 35;
    let allowedMetas = 0;

    if (!metas) {
        return 0;
    }

    for (const meta of metas) {
        accChar += meta.code?.length;
        accChar += 5; // represent the padding and margin between tags

        if (accChar > maxChar) {
            break;
        } else {
            allowedMetas++;
        }
    }

    return allowedMetas;
};

export default getMaxMetasAllowed;
